import React, { useRef, useState, useEffect, useReducer  } from 'react';
import styled from 'styled-components';
import useChatActions from '../../../hooks/chat/useChatActions';
import { useChat } from '../../../context/provider/ChatProvider';
import { seleccionarArchivo, eventPaste, eventDrag, eventDrop, eliminarTodasLasExtensiones, obtenerExtension, notify } from '../../../utils/utils';
import { Tooltip } from '../utils/Tooltip';

const MessageForm = styled.form`
    display: flex;
    align-items: end;
    position: relative;
    height: 20%;
`;

const EmoticonsContainer = styled.div`
    position: absolute;
    top: -100%; /* Esconde el div de emoticones */
    left: 0;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px;
    z-index: 1;
    transition: top 0.3s ease-in-out;
`;

const archivoReducer = (estado, accion) => {
    switch(accion.tipo) {
        case 'Agregar':
            return [...estado, ...accion.carga]
        case 'Remover':
            return estado.filter(file => file?.codigo
                    ? file.codigo !== accion.carga.codigo
                    : file.identificador !== accion.carga.identificador
            )
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado
    }
}

const ChatForm = () => {
    const inputRef = useRef(null);
    const { sendMessage } = useChatActions();
    const { currentRoom, userName, messageToReply, setMessageToReply } = useChat();
    const [showEmoticons, setShowEmoticons] = useState(false);
    const [sendWithEnter, setSendWithEnter] = useState(false);
    const [fijarMensaje, setFijarMensaje ] = useState(false)
    const [archivo, setArchivo] = useReducer(archivoReducer, [])
    const [esArrastrar, setEsArrastrar] = useState(false)

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === 'Enter' && sendWithEnter) {
                onSubmit(e);
            }
        };

        document.addEventListener('keypress', handleKeyPress);

        return () => {
            document.removeEventListener('keypress', handleKeyPress);
        };
    }, [sendWithEnter]);

    const toggleEmoticons = () => {
        setShowEmoticons(!showEmoticons);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const texto = inputRef.current.value.trim()

        if (texto === "" && archivo.length === 0) {
            inputRef.current.focus()
            return
        }

        const urlMinio = await subirArchivo()
        const mediaFile = {
            mime: archivo.length > 0 ? archivo[0].type : "text/plain",
            original: archivo.length > 0 ? archivo[0].nombre : "",
            type: archivo.length > 0 ? archivo[0].type : "text/plain",
            size: archivo.length > 0 ? archivo[0].size : 0,
            url: archivo.length > 0 ? (archivo[0].type.startsWith("image/") ? urlMinio.urlVer : urlMinio.urlDescargar) : "",
            key: ""
        }

        const messageType =
            archivo.length > 0
                ? (
                    archivo[0].type.startsWith("image/")
                        ? "image"
                        : (
                            archivo[0].type.startsWith("video/")
                                ? "video"
                                : "file"
                        )
                )
                : "text";

        sendMessage(
            currentRoom, 
            texto.length > 0 ? texto : (archivo.length > 0 ? " " : "" ),
            userName,
            messageType,
            archivo.length > 0 ? mediaFile : null,
            messageToReply
        )

        inputRef.current.value = ""
        inputRef.current.focus()
        setMessageToReply(null)

        if (archivo.length > 0) {
            setArchivo({
                tipo:"Remover",
                carga:archivo[0]
            })
        }
    }

    const subirArchivo = async () => {
        if (archivo.length === 0) {
            return { urlVer: "", urlDescargar: ""}
        }
        const file = archivo[0]
        const nomCarpeta = "comunichat-files"
        const nomArchivo = eliminarTodasLasExtensiones(file.nombre)
        const formData = new FormData()
        const blob = file.slice(0, file.size, "application/json")
        const nuevoArchivo = new File([blob], file.nombre, { type: 'aplication/json' })
        formData.append('archivo',nuevoArchivo)
        const queryParameters = {
            NombreCarpeta: nomCarpeta,
            NombreSubCarpeta : "",
            nombreArchivo: nomArchivo
        }
        const urlEnvioMinio = 'https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?' + new URLSearchParams(queryParameters)
        const urlVerImagen = `https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=${nomCarpeta}&NombreImagen=${nomArchivo}`
        const urlDescargar = `https://miniowebapi.abexacloud.com/api/Archivo/descargarArchivo?NombreCarpeta=${nomCarpeta}&NombreArchivo=${nomArchivo}&Extension=${obtenerExtension(file.nombre)}`

        const response = await fetch(urlEnvioMinio,{
            method:'POST',
            body: formData
        }).then(res => res.json())

        !response.isValid && notify(response.content , 'error')
        return response.isValid ? {urlVer: urlVerImagen, urlDescargar: urlDescargar} : {urlVer: "" , urlDescargar: ""}
    }


    return (
        <MessageForm onSubmit={onSubmit}> 
            <div className='text-xs absolute top-0'>
                <input type="checkbox" id="sendWithEnter" checked={sendWithEnter} onChange={() => setSendWithEnter(!sendWithEnter)} />
                <label   htmlFor="sendWithEnter">Enviar con Enter</label>
            </div>

            <div className='text-xs absolute top-5'>
                <input type="checkbox" id="fijarMensaje" checked={fijarMensaje} onChange={() => setFijarMensaje(!fijarMensaje)} />
                <label   htmlFor="fijarMensaje">Fijar Mensaje</label>
            </div>

            <div
                className="w-full"
                onPaste={(e) => eventPaste(e, setArchivo, archivo.length > 0)}
                onDragOver={(e) => eventDrag(e, setEsArrastrar, archivo.length > 0)}
                onDragLeave={() => setEsArrastrar(false)}
                onDrop={(e) => eventDrop(e, setArchivo,setEsArrastrar, archivo.length > 0)}
            >
                {
                    !esArrastrar ?
                    (
                        <div className='w-full flex h-[50%] flex-col relative'>

                            {messageToReply && (
                                <div className="absolute -top-12 left-10 right-14 bg-zinc-800 border-l-4 border-blue-500 p-2 text-white flex justify-between items-center rounded-t-md shadow-lg z-10 h-12">
                                    <div className="flex flex-col truncate w-11/12">
                                        <span className="text-xs font-bold text-blue-400">
                                            Respondiendo a {messageToReply.owner.nickname}
                                        </span>
                                        <span className="text-xs truncate text-gray-300">
                                            {messageToReply.messageType === 'text' ? messageToReply.content : 'Archivo adjunto'}
                                        </span>
                                    </div>
                                    <button 
                                        type="button"
                                        className="text-gray-400 hover:text-white px-2 fa-solid fa-xmark cursor-pointer"
                                        onClick={() => setMessageToReply(null)}
                                    ></button>
                                </div>
                            )}
                            <div className="flex w-full items-center">
                                <button type="button" className="fa fa-smile text-4xl px-2 lg:text-base" onClick={toggleEmoticons} />
                                <input type="file" className="hidden" id="fileInput" onChange={(e) => seleccionarArchivo(e, setArchivo)} />
                                <label
                                    htmlFor="fileInput"
                                    className={`${archivo.length > 0 ? "hidden" : "cursor-pointer px-2 flex items-center"}`}
                                >
                                    <i
                                        className="fa-solid fa-paperclip text-xl text-zinc-500"
                                        data-tip="Adjuntar archivo"
                                        data-for="icon-adjuntar"
                                    ></i>

                                    <Tooltip id="icon-adjuntar">Adjuntar archivo</Tooltip>
                                </label>

                                <fieldset
                                    className={`
                                        ${archivo.length > 0 ? "w-[64px] h-[64px]" : "hidden"}
                                        flex
                                        items-center
                                        justify-center
                                        border
                                        border-zinc-400
                                        rounded
                                        px-1
                                        mr-2
                                    `}
                                >
                                    <legend className="text-xs text-zinc-500">Adjunto</legend>
                                    {
                                        archivo.length > 0 &&
                                        <div className="w-[40px] h-[40px] relative">
                                            {
                                                archivo[0].type.startsWith("image/") ?
                                                    <img
                                                        src={URL.createObjectURL(archivo[0])}
                                                        alt="Adjunto"
                                                        className="w-full h-full object-cover cursor-pointer"
                                                        onClick={() =>
                                                            window.open(URL.createObjectURL(archivo[0]),"_blank")
                                                        }
                                                    />
                                                :
                                                    <span className="text-3xl">
                                                        {
                                                            archivo[0].type.startsWith("video/") ? "🎞️" : "📄"
                                                        }
                                                    </span>
                                            }

                                            <i className="fa-solid fa-square-xmark absolute -top-2 -right-2 text-red-500 cursor-pointer"
                                                onClick={() =>
                                                    setArchivo({
                                                        tipo:"Remover",
                                                        carga:archivo[0]
                                                    })
                                                }
                                                data-tip="Eliminar archivo"
                                                data-for="icon-remove"
                                            ></i>
                                            <Tooltip id="icon-remove">Eliminar archivo</Tooltip>
                                        </div>
                                    }
                                </fieldset>

                                <textarea ref={inputRef} className="rounded  text-black p-2 caret-black flex-1 h-[64px] resize-none mx-2 lg:placeholder:text-xs" placeholder="Escriba su mensaje aquí" />
                                <button className="text-white bg-green-600 fa fa-paper-plane px-3 py-3 rounded lg:text-base" ></button>
                            </div>
                        </div>
                    ) : 
                    (
                        <div className="w-full h-[64px] border border-dashed border-zinc-400 flex justify-center items-center opacity-70" >
                            Deje el archivo aquí...
                        </div>
                    )
                }
            </div>                
        </MessageForm>
    );
};

export default ChatForm;
